import React, { useState, useEffect } from "react";
import { MessageCircle, Phone } from "lucide-react";

const WA_TEXT = encodeURIComponent("היי, אשמח לשמוע פרטים נוספים");

const WhatsAppButton: React.FC = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setReady(true), 1200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className="fixed bottom-5 left-5 z-50 flex flex-col gap-2.5"
      style={{
        opacity: ready ? 1 : 0,
        transform: ready ? "none" : "translateY(20px)",
        transition: "opacity 600ms cubic-bezier(0.16,1,0.3,1), transform 600ms cubic-bezier(0.16,1,0.3,1)",
      }}
    >
      <a
        href="tel:+972557070007"
        className="group hidden h-12 w-12 items-center justify-center border border-[var(--line-strong)] bg-ink/85 text-fg shadow-md backdrop-blur-md transition-all duration-300 ease-out-quart hover:border-signal hover:text-signal sm:flex"
        aria-label="התקשרו עכשיו"
      >
        <Phone className="h-[18px] w-[18px]" />
      </a>

      <a
        href={`https://wa.me/972557070007?text=${WA_TEXT}`}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex h-11 w-11 items-center justify-center bg-signal text-[#04120c] shadow-md transition-all duration-300 ease-out-quart hover:bg-[#22f2b3] sm:h-12 sm:w-12"
        aria-label="שלחו הודעה בוואטסאפ"
      >
        <MessageCircle className="h-[18px] w-[18px]" />
      </a>
    </div>
  );
};

export default WhatsAppButton;
